import { JSX } from 'preact'
import { useEffect } from 'preact/hooks'

type Props = JSX.IntrinsicElements['button']

declare global {
    interface Window {
        HiBot: unknown
    }
}

function HiBotButton(props: Props) {
    useEffect(() => {
        // deno-lint-ignore no-window
        if (window.HiBot) return

        const url =
            'https://cdn-bot.hiplatform.com/dtbot.js?token=f815cdfe-0e37-4ce0-9e61-c1911083d8c0'

        const _script = document.createElement('script')
        _script.async = true
        _script.id = 'dtbot-script'
        _script.src = url

        setTimeout(() => {
            document.body.appendChild(_script)
        }, 3000)
    }, [])

    return (
        <button
            type='button'
            {...props}
            onClick={() => {
                const hibotChat2 = document.querySelector<HTMLElement>('#dtbot-iframe')
                const hibotChat = document.querySelector<HTMLElement>(
                    '#ib-button-messaging',
                )

                if (!hibotChat) {
                    if (hibotChat2) {
                        hibotChat2.style.opacity = '1'
                        hibotChat2.classList.add('shown')
                        hibotChat2.click()
                    }
                    return
                }

                hibotChat.click()
            }}
        />
    )
}

export default HiBotButton
